import React from "react";

function ClothingForm({ additionalAttributes, setAdditionalAttributes }) {
  const handleChange = (e) => {
    setAdditionalAttributes({
      ...additionalAttributes,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="clothingForm">
      {/* Kateqoriya */}
      <div>
        <h3>Kateqoriya <span>*</span></h3>
        <select name="category" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Kişi">Kişi</option>
          <option value="Qadın">Qadın</option>
          <option value="Uşaq">Uşaq</option>
        </select>
      </div>

      {/* Geyim/Ayaqqabı növü */}
      <div>
        <h3>Geyim/Ayaqqabı növü <span>*</span></h3>
        <select name="type" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Köynək">Köynək</option>
          <option value="Şalvar">Şalvar</option>
          <option value="Gödəkçə">Gödəkçə</option>
          <option value="Ayaqqabı">Ayaqqabı</option>
          <option value="İdman geyimi">İdman geyimi</option>
        </select>
      </div>

      {/* Ölçü */}
      <div>
        <h3>Ölçü <span>*</span></h3>
        <select name="size" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="XS">XS</option>
          <option value="S">S</option>
          <option value="M">M</option>
          <option value="L">L</option>
          <option value="XL">XL</option>
          <option value="XXL">XXL</option>
        </select>
      </div>

      {/* Material növü */}
      <div>
        <h3>Material <span>*</span></h3>
        <select name="material" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Pambıq">Pambıq</option>
          <option value="Dəri">Dəri</option>
          <option value="Polyester">Polyester</option>
          <option value="Sintetik">Sintetik</option>
        </select>
      </div>

      {/* Rəng */}
      <div>
        <h3>Rəng <span>*</span></h3>
        <input type="text" name="color" required placeholder="Rəngi daxil edin" onChange={handleChange} />
      </div>

      {/* Brend */}
      <div>
        <h3>Marka <span>*</span></h3>
        <input type="text" name="brand" required placeholder="Marka adını daxil edin" onChange={handleChange} />
      </div>

      {/* Yeni və ya istifadə olunmuş */}
      <div>
        <h3>İstifadə vəziyyəti <span>*</span></h3>
        <select name="condition" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Yeni">Yeni</option>
          <option value="İkinci əl">İkinci əl</option>
        </select>
      </div>

    </div>
  );
}

export default ClothingForm;
